export const trackResponse = data =>
  fetch(`/api/v1/experiment/track?${$.param(data)}`, {
    credentials: "include",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json"
    }
  });
